/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react';
import html2canvas from 'html2canvas';
import './index.scss';
import classNames from 'classnames';
interface Props {
  finish: any;
  iOld: boolean;
  children?: any;
}
class InviteImg extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.state = {
      name: 'React',
    };
  }
  componentDidMount() {
    html2canvas(document.getElementById('code-image') as any, {
      useCORS: true,
      scale: window.devicePixelRatio,
    }).then((canvas) => {
      const base64 = canvas.toDataURL('image/png').split(',')[1];
      this.props.finish(base64);
    });
  }
  render() {
    return (
      <div
        id="code-image"
        className={classNames('code-image', { new: !this.props.iOld })}
      >
        <img className="cash-icon" src="https://diy-assets.msstatic.com/kjmain/cash-icon.png"/>
        <img
          src={`https://diy-assets.msstatic.com/kjmain/${
            this.props.iOld ? 'code-image' : 'code-image-new'
          }.png`}
        />
        <div className="code-image-cont">
          <div className="code">{this.props.children}</div>
          <h3>
            <img src="https://diy-assets.msstatic.com/kjmain/code-btn.png" />
            {this.props.iOld ? '长按识别，立即领现金' : ''}
          </h3>
          <p className="code-desc">可使用微信、QQ、浏览器及虎牙直播App扫码</p>
          <p className="code-bottom-desc">
            首次登录虎牙直播app，即可无门槛领取微信零钱
          </p>
          <div className="code-bottom" />
          <ul className="code-bottom-desc-2">
            {['长按识别二维码', '下载虎牙直播APP', '登录领取现金'].map(
              (item) => (
                <li key={item}>{item}</li>
              )
            )}
          </ul>
        </div>
      </div>
    );
  }
}

export default InviteImg;
